<script>
import baseMixin from '@/mixins/baseMixin'
import bookingListMixin from '@/mixins/bookingListMixin'
import { nanoid } from 'nanoid'

export default {
  name: 'BookingListSkeleton',
  mixins: [baseMixin, bookingListMixin],
  props: {
    rows: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    compMockBookingData() {
      const mockDataArray = []

      // eslint-disable-next-line no-unused-vars
      for (let i = 0; i < this.rows; ++i) {
        const mockBooking = {}

        // HACK: v-data-table will complain if there is duplicate ids in the table
        // so I've populated the data with nanoid
        for (const column of this.columns) {
          mockBooking[`${column.value}`] = nanoid()
        }

        mockDataArray.push(mockBooking)
      }

      return mockDataArray
    },
  },
}
</script>

<template>
  <section>
    <v-data-table
      :headers="columns"
      :items="compMockBookingData"
      class="custom-elevation rounded-xl mb-8"
      hide-default-footer
      disable-sort
    >
      <template v-slot:[`item.id`]="">
        <v-skeleton-loader type="text"></v-skeleton-loader>
      </template>

      <template v-slot:[`item.name`]="">
        <v-skeleton-loader type="text"></v-skeleton-loader>
      </template>

      <template v-slot:[`item.status`]="">
        <v-skeleton-loader type="text"></v-skeleton-loader>
      </template>

      <template v-slot:[`item.time`]="">
        <v-skeleton-loader type="text"></v-skeleton-loader>
      </template>

      <template v-slot:[`item.type`]="">
        <v-skeleton-loader type="text"></v-skeleton-loader>
        <div class="d-flex flex-rows">
          <v-skeleton-loader class="mr-4" type="chip"></v-skeleton-loader>
          <v-skeleton-loader type="chip"></v-skeleton-loader>
        </div>
      </template>

      <template v-slot:[`item.certifications`]="">
        <div class="d-flex flex-rows">
          <v-skeleton-loader class="mr-4" type="chip"></v-skeleton-loader>
          <v-skeleton-loader type="chip"></v-skeleton-loader>
        </div>
      </template>

      <template v-slot:[`item.policies`]="">
        <div class="d-flex flex-rows">
          <v-skeleton-loader class="mr-4" type="chip"></v-skeleton-loader>
          <v-skeleton-loader type="chip"></v-skeleton-loader>
        </div>
      </template>

      <template v-slot:[`item.replacing`]="">
        <v-skeleton-loader type="text"></v-skeleton-loader>
      </template>

      <template v-slot:[`item.actions`]="">
        <v-btn disabled icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </section>
</template>

<style lang="scss" scoped>
@import '@styles';

::v-deep.v-skeleton-loader--is-loading {
  .v-skeleton-loader__chip {
    width: 64px; // change width or height here
    height: 16px;
  }
}
</style>
